/**
 * API Configuration utility
 * Dynamically determines the backend URL based on environment variables
 */

import { getConfig } from './config';

const getApiBaseUrl = (): string => {
  const config = getConfig();
  const apiBase = config.apiBase;

  console.log(`Using API base URL: ${apiBase}`);

  switch (apiBase) {
    case 'localhost':
      return 'http://localhost:8081';
    case 'staging.polarisathletehub.com':
      return 'https://staging.polarisathletehub.com';
    case 'polarisathletehub.com':
      return 'https://polarisathletehub.com';
    default:
      // For any other domain, assume HTTPS and port 8081
      return `https://${apiBase}:8081`;
  }
};

export const API_BASE_URL = getApiBaseUrl();

/**
 * Helper function to build full API URLs
 * @param endpoint - The API endpoint (e.g., '/api/athletes')
 * @returns Full URL string
 */
export const buildApiUrl = (endpoint: string): string => {
  // Remove leading slash if present to avoid double slashes
  const cleanEndpoint = endpoint.startsWith('/') ? endpoint.slice(1) : endpoint;
  return `${API_BASE_URL}/${cleanEndpoint}`;
};

/**
 * Helper function to build OAuth URLs
 * @param provider - OAuth provider (e.g., 'google')
 * @returns Full OAuth URL string
 */
export const buildOAuthUrl = (provider: string): string => {
  return `${API_BASE_URL}/oauth2/authorization/${provider}`;
};
